import {
  authActionsType, CURRENT_LANG
} from '../../constants';
import { commonService } from 'src/services';

const logout = () => {
  return async dispatch => {
    try {
      await commonService.post('Logout', null);

      // Nettoyage local
      const lang = localStorage.getItem(CURRENT_LANG);
      localStorage.clear();
      localStorage.setItem(CURRENT_LANG, lang);

      dispatch({ type: authActionsType.LOGOUT });
    } catch (error) {
      console.error("Erreur de déconnexion", error);
    }
  };
};


export const authActions = {
  logout
};